import { useEffect } from 'react';
import { useToken } from '../hooks/useToken';
import { client } from '../utils/client';
import { EmptyContainer } from './';

/**
 * Redirects the running user to the authorization url
 * @returns the component
 */
export const RedirectToLogout = () => {
  const [, setToken] = useToken();

  useEffect(() => {
    handleLogout();
  });

  const handleLogout = async () => {
    let logoutUrl = '/';

    try {
      // Step 1: Clear token from React context FIRST to prevent race conditions
      setToken(undefined);

      // Step 2: Call logout which will clear tokens on multiple domains and redirect
      logoutUrl = await client.logout();
    } catch (e) {
      console.log('error while revoking token', e);
      // Even on error, ensure token is cleared and redirect to login
      setToken(undefined);
      logoutUrl = '/login';
    } finally {
      // Step 3: Small delay to ensure token is cleared from context and multi-domain clearing completes
      await new Promise((resolve) => setTimeout(resolve, 100));

      // Step 4: Redirect to logout URL
      window.location.href = logoutUrl;
    }
  };

  return <EmptyContainer icon={'login'} message={'Logging out...'} />;
};
